module.exports = __webpack_public_path__ + "img/f8a2124.png";